module.exports = __webpack_public_path__ + "static/media/no-trips.377ec071.svg";